// Where Meta's own tool lives, as a link the USER follows — never a host this package requests (T-329, BUG-193).
//
// The one URL a real account's `AdsManagerLink` carries (API §4.4, `kind: "home"`): Ads Manager's own front
// door, with nothing after it. HARD RULE 2 / REQ-002 AC3 / REQ-104 AC5 — never `act_<id>`, never an entity
// id, never a pixel id, never a query string, never a token. The demo server writes it into an entity's page
// and into every checklist line of a live dataset; the apps hold the same constant for the pointers they draw
// from `capabilities.canOpenAdsManager` alone (`META_TOOL.adsManager.url`, a declared twin until they adopt
// this one). It lives here, on the root entry beside the API client, and NOT under `src/demo`, because that
// folder's no-network guard (`noNetwork.test.ts`, ARCH §8.3) admits exactly one URL literal and this is not
// something the demo server fetches — it is a string the owner clicks.

/** Ads Manager's home. A link out of the product; nothing is ever requested from it by this package. */
export const ADS_MANAGER_HOME_URL = 'https://adsmanager.facebook.com/';
